module.exports = __webpack_public_path__ + "img/process-3.a77f6eac.png";